import script from "./EcommerceMensajesView.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceMensajesView.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceMensajesView.vue?vue&type=style&index=0&id=0d2d5044&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d2d5044"]])

export default __exports__